module.exports = __webpack_public_path__ + "img/Group 17.1df15eca.svg";